module.exports = __webpack_public_path__ + "static/img/THE GARDEN OF EVA 6 SIMONE STEENBERG.6bf9bb1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue11/THE GARDEN OF EVA 6 SIMONE STEENBERG.jpg
// module id = hmw6
// module chunks = 7